import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import type { HistoryEntry } from '../../types/e2i';
import { formatDateTime } from '../../utils/e2i';

const ENTITY_LABELS: Record<string, string> = {
  enquiry: 'Enquiry',
  estimate: 'Estimate',
  quotation: 'Quotation',
  job: 'Job',
  cir: 'Invoice request',
  register: 'Register',
};

const entityLabel = (entity: string): string => ENTITY_LABELS[String(entity || '').toLowerCase()] || entity || '';

/** Everything that happened on the enquiry and its documents, newest first as the server sends it. */
const HistoryList: React.FC<{ history: HistoryEntry[] }> = ({ history }) => {
  if (!history.length) return <Typography variant="body2" color="text.secondary">No history yet.</Typography>;
  return (
    <Stack component="ol" spacing={1} sx={{ m: 0, p: 0, listStyle: 'none' }}>
      {history.map((h, i) => (
        <Box component="li" key={`${h.at}-${i}`} sx={{ borderBottom: '1px solid #eceff1', pb: 1 }}>
          <Typography variant="body2">
            {h.entity ? <Box component="span" sx={{ color: 'text.secondary' }}>{entityLabel(h.entity)} · </Box> : null}
            <strong>{h.action}</strong>
            {h.userName ? ` · ${h.userName}` : ''}
          </Typography>
          <Typography variant="caption" color="text.secondary">{formatDateTime(h.at)}</Typography>
          {h.comment ? <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: 'pre-line' }}>{h.comment}</Typography> : null}
        </Box>
      ))}
    </Stack>
  );
};

export default HistoryList;
